export const DOWNLOAD_FRAME_LIFETIME_MS = 60_000

/**
 * Browsers ignore `<a download>` on cross-origin URLs and navigate the page instead, which aborts its
 * in-flight requests (Firefox even when the response is a download). A hidden iframe confines that.
 */
export const startDownload = (url: string): void => {
  const frame = document.createElement('iframe')
  frame.hidden = true
  frame.src = url
  document.body.appendChild(frame)
  // Removing the frame before the response headers arrive would cancel the download.
  setTimeout(() => frame.remove(), DOWNLOAD_FRAME_LIFETIME_MS)
}
